import { render, staticRenderFns } from "./defaultExchange.vue?vue&type=template&id=0c89de91&scoped=true&"
import script from "./defaultExchange.vue?vue&type=script&lang=js&"
export * from "./defaultExchange.vue?vue&type=script&lang=js&"
import style0 from "./defaultExchange.vue?vue&type=style&index=0&id=0c89de91&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c89de91",
  null
  
)

export default component.exports